import { render, staticRenderFns } from "./ReportManagement.vue?vue&type=template&id=718e01c6&scoped=true&"
import script from "./ReportManagement.vue?vue&type=script&lang=js&"
export * from "./ReportManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e01c6",
  null
  
)

export default component.exports